<template functional>
  <div
    :style="props.couponStyle"
    :class="[
      'coupon-scroll',
      {
        deactive: !props.canGet
      }
    ]"
    @click="listeners['receive-coupon']"
  >
    <div class="info">
      <p class="title">
        <span class="symbol">¥</span>
        <span class="value">{{ props.couponValue }}</span>
      </p>
      <p class="type">
        {{ props.couponName }}
      </p>
      <p class="threshold">
        {{ props.thresholdMsg }}
      </p>
    </div>
    <div v-if="props.canGet" class="action">
      <p>立即领取</p>
    </div>
    <img
      v-if="props.stockStatus === 1"
      :src="injections.iconHasGot"
      class="stamp"
    />
    <img
      v-if="props.stockStatus === 2"
      :src="injections.iconNoStock"
      class="stamp"
    />
  </div>
</template>

<script>
import iconHasGot from '@/images/cms/coupons/stamp_h_received@2x.png'
import iconNoStock from '@/images/cms/coupons/stamp_h_none@2x.png'

export default {
  name: 'CouponScroll',
  inject: {
    iconHasGot: {
      default: iconHasGot
    },
    iconNoStock: {
      default: iconNoStock
    }
  },
  props: {
    coupon: {
      type: Object,
      default: () => ({})
    },
    couponStyle: {
      type: Object,
      default: () => ({})
    },
    stockStatus: {
      type: Number,
      default: 0
    },
    canGet: {
      type: Boolean,
      default: true
    },
    couponValue: {
      type: Number,
      default: 0
    },
    couponName: {
      type: String,
      default: ''
    },
    thresholdMsg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-scroll {
  position: relative;

  width: 105px;
  height: 58px;
  padding: 12px;
  overflow: hidden;

  background-image: url('~@/images/cms/coupons/bg_h@2x.png');
  background-repeat: no-repeat;

  flex: none;
  background-size: 100% 100%;

  @include flex(row, space-between, center, nowrap);

  .info {
    width: 50px;

    flex: auto;

    .title {
      @include flex(row, flex-start, flex-end, nowrap);

      .symbol,
      .value {
        color: white;
      }

      .symbol {
        position: relative;
        bottom: 2px;

        margin-right: 1px;

        font-size: 12px;
        font-weight: $fw-regular;
      }

      .value {
        font-size: 24px;
        font-weight: $fw-bold;
      }
    }

    .type {
      margin-top: 2px;

      font-size: 11px;
      color: white;

      @include text-overflow-ellipsis-single;
    }

    .threshold {
      margin-top: 2px;

      opacity: 0.6;

      font-size: 10px;
      line-height: 12px;
      color: white;

      @include text-overflow-ellipsis-single;
    }
  }

  .action {
    width: 20px;

    flex: none;

    @include flex-row-center;

    p {
      font-size: 12px;
      letter-spacing: 2px;

      color: white;
      writing-mode: vertical-lr;
    }
  }

  .stamp {
    position: absolute;
    right: -9px;
    bottom: -17px;
    z-index: 2;

    width: 65px;
    height: 65px;
  }

  &.deactive {
    background-image: url('~@/images/cms/coupons/bg_h_grey@2x.png');
  }
}
</style>
